import { jsx as _jsx } from "react/jsx-runtime";
import legalDocuments from '@phishtool/legal-documents';
import Legal from '~components/legal';
const TermsOfService = () => _jsx(Legal, { heading: "Terms of Service", content: legalDocuments.termsOfService });
export default TermsOfService;
